import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: window?.location?.host,
  projectId: process.env.REACT_APP_GCP_PROJECT,
  storageBucket: `${process.env.REACT_APP_GCP_PROJECT}.appspot.com`,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const firebaseApp = initializeApp(firebaseConfig)
const firebaseAuth = getAuth(firebaseApp)

export {
  firebaseAuth,
}

export {
  connectAuthEmulator,
  getRedirectResult,
  SAMLAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  signOut,
} from 'firebase/auth'

export type {
  User,
  UserCredential,
} from 'firebase/auth'
